import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=80ce1f68&scoped=true"
import script from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=80ce1f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ce1f68",
  null
  
)

export default component.exports